/**
 * @generated SignedSource<<365d9e91b4b01842ded07194f371a7a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScheduleItemFragment$data = {
  readonly assignee: string | null | undefined;
  readonly bond_ee: string | null | undefined;
  readonly bond_es: string | null | undefined;
  readonly bond_left: string | null | undefined;
  readonly bond_parent_ee: string | null | undefined;
  readonly bond_parent_es: string | null | undefined;
  readonly bond_parent_se: string | null | undefined;
  readonly bond_parent_ss: string | null | undefined;
  readonly bond_right: string | null | undefined;
  readonly bond_se: string | null | undefined;
  readonly bond_ss: string | null | undefined;
  readonly children: string | null | undefined;
  readonly color: string | null | undefined;
  readonly completion_percentage: number | null | undefined;
  readonly contract_invoice: string | null | undefined;
  readonly cost_code_id: number | null | undefined;
  readonly count_days: number | null | undefined;
  readonly count_hours: number | null | undefined;
  readonly count_material: number | null | undefined;
  readonly count_people: number | null | undefined;
  readonly count_tools: number | null | undefined;
  readonly description: string | null | undefined;
  readonly division_id: number | null | undefined;
  readonly duration: string | null | undefined;
  readonly end_datetime: string | null | undefined;
  readonly end_format_datetime: string | null | undefined;
  readonly equipment_hours: number | null | undefined;
  readonly id: string | null | undefined;
  readonly material_hours: number | null | undefined;
  readonly name: string;
  readonly number_wbs: string | null | undefined;
  readonly owner_item_id: string | null | undefined;
  readonly parent_id: string | null | undefined;
  readonly phase_id: number | null | undefined;
  readonly priority: number | null | undefined;
  readonly project_id: string | null | undefined;
  readonly role_item: string;
  readonly start_datetime: string | null | undefined;
  readonly start_format_datetime: string | null | undefined;
  readonly status: number | null | undefined;
  readonly type: number | null | undefined;
  readonly value_equipment: number | null | undefined;
  readonly value_labour: number | null | undefined;
  readonly value_material: number | null | undefined;
  readonly value_other: number | null | undefined;
  readonly value_total: number | null | undefined;
  readonly wo_si: string | null | undefined;
  readonly " $fragmentType": "ScheduleItemFragment";
};
export type ScheduleItemFragment$key = {
  readonly " $data"?: ScheduleItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScheduleItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start_datetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end_datetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_left",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_right",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_parent_ss",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_parent_se",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_parent_ee",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_parent_es",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_ss",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_se",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_ee",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bond_es",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completion_percentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cost_code_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number_wbs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "project_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner_item_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "division_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parent_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "children",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role_item",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contract_invoice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count_hours",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count_days",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count_people",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "equipment_hours",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count_tools",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count_material",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "material_hours",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value_equipment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value_labour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wo_si",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value_material",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value_other",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value_total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start_format_datetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end_format_datetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignee",
      "storageKey": null
    }
  ],
  "type": "ScheduleItem",
  "abstractKey": null
};

(node as any).hash = "8bc711ce85470926600214b058c3daa2";

export default node;
